import Button from '@ds/components/actions/Button';
import { ExternalLinkIcon } from '@ds/icons';
import useAppNavigate from '@effects/useAppNavigate';
import React from 'react';

type LinkType = 'internal' | 'external';

interface Props {
    type: LinkType;
    title?: string;
    path: string;
    preAction?: () => void;
    internal?: {
        isActive: boolean;
    };
    external?: {
        newTab: boolean;
        showIcon: boolean;
    };
}

const NavItem: React.FunctionComponent<Props> = ({ type, title, path, internal, external, preAction }) => {
    const navigate = useAppNavigate();
    const titleText = title || path;

    return (
        <>
            {type === 'internal' && (
                <Button
                    variant="text"
                    // Nav titles are authored product names ("eNVD Profile", "eDECs"), so they
                    // render as written rather than taking Button's default capital first letter.
                    preserveCase
                    // Button holds its pressed visual while `aria-current="page"` is set, so the
                    // current route's item stays selected — and is announced as the current page.
                    aria-current={internal?.isActive ? 'page' : undefined}
                    onClick={() => {
                        if (preAction) {
                            preAction();
                        } else {
                            navigate(path);
                        }
                    }}
                >
                    {titleText}
                </Button>
            )}
            {type === 'external' && (
                <Button
                    variant="text"
                    preserveCase
                    onClick={() => {
                        if (preAction) {
                            preAction();
                        } else {
                            if (external?.newTab) {
                                window.open(path, '_blank');
                            } else {
                                window.location.href = path;
                            }
                        }
                    }}
                    // Decorative: the Button already takes its accessible name from
                    // `titleText`, and its size comes from Button's own `.icon` slot
                    // rule, so the icon needs neither a label nor a `size`.
                    startIcon={external?.showIcon && <ExternalLinkIcon />}
                >
                    {titleText}
                </Button>
            )}
        </>
    );
};

export default NavItem;
